export default {
      id: "top-menu-patients-directory-up-usage",
      viewBox: "0 0 28 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#top-menu-patients-directory-up",
      toString: function () {
        return this.url;
      }
    }